module.exports = __webpack_public_path__ + "static/media/DSC_0866.1f9e601e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0866.jpg
// module id = 606
// module chunks = 0